import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Injectable()
export class PlayerDiscountService {
  private _apiUrl = '/api/PlayerDiscount';

  constructor(private _http: HttpService, private _httpClient: HttpClient) { }

  getPlayerProfileData(userToken: string) {
    return this._http.get(
      this._apiUrl + `/get-player-profile-data/${userToken}`
    );
  }

  addNewPlayerVideo(videoData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this._http.post(this._apiUrl +'/add-player-video', videoData, httpOptions);
  }

  updatePlayerProfileFollowStatus(socialMedia: string, playerID: number){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this._http.post(this._apiUrl +'/update-player-profile-follow-status/'+socialMedia+'/'+playerID, httpOptions);
  }

  sendPromoCodeToPlayer(playerID: number){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this._http.post(this._apiUrl +'/send-promo-code-to-player/'+playerID, httpOptions);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/player-discount.service.ts